module.exports = __webpack_public_path__ + "img/cv.58e2e974.svg";